var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("批改详情"),
      visible: _vm.detailVisible,
      width: 1000,
      closable: false
    }
  }, [_c("div", {
    staticClass: "footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      width: "80px"
    },
    attrs: {
      slot: "footer",
      type: "primary",
      ghost: ""
    },
    on: {
      click: function ($event) {
        return _vm.$emit("closeDetail");
      }
    },
    slot: "footer"
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1), _vm.detailVisible ? _c("a-table", {
    attrs: {
      dataSource: _vm.dataSource,
      pagination: _vm.pagination,
      columns: _vm.columns,
      scroll: {
        x: 900,
        y: 300
      }
    },
    on: {
      change: _vm.handleStandardTableChange
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t("批改详情")))]), _c("div", {
    staticClass: "detail-content"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("自1零时起进行如下变更").replace("1", _vm.effectiveAt)) + "： "), _vm.detailInfo.replaceItemsLength ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("替换人员清单") + ":") + " "), _vm._l(_vm.detailInfo.replaceItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t("姓名由") + item.REDUCE.name + _vm.$t("变更为") + item.INCREASE.name) + ", " + _vm._s(_vm.$t("证件号码由-变更为_").replace("-", item.REDUCE.idNumber).replace("_", item.INCREASE.idNumber)) + " "), _c("span", [_vm._v(_vm._s(index === _vm.detailInfo.replaceItemsLength - 1 ? "。" : ",") + " ")])]);
  })], 2) : _vm._e(), _vm.detailInfo.incrementItemsLength ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("新增人员清单") + ":") + " "), _vm._l(_vm.detailInfo.incrementItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t("姓名") + item.name) + "," + _vm._s(_vm.$t("证件号码") + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === _vm.detailInfo.incrementItemsLength - 1 ? "。" : ","))])]);
  })], 2) : _vm._e(), _vm.detailInfo.reduceItemsLength ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("减少人员清单") + ":") + " "), _vm._l(_vm.detailInfo.reduceItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t("姓名") + item.name) + "," + _vm._s(_vm.$t("证件号码") + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === _vm.detailInfo.reduceItemsLength - 1 ? "。" : ","))])]);
  })], 2) : _vm._e()]), _vm.policyPurpose === "other" ? _c("span", {
    staticClass: "key-value"
  }, [_vm._v(_vm._s(_vm.$t("综上所述：")) + _vm._s(_vm.$t("由此需要")) + _vm._s(_vm.detailInfo.premiumType === "INCREASE" ? _vm.$t("加收") : _vm.$t("退还")) + "：" + _vm._s(_vm.detailInfo.premium) + "元 ")]) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };